import { render, staticRenderFns } from "./LegacyCreateOrderView.vue?vue&type=template&id=f3564750"
import script from "./LegacyCreateOrderView.vue?vue&type=script&lang=js"
export * from "./LegacyCreateOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports